
import React from "react";
import { Link } from "@/hooks/useLinks";
import { LinkIcon } from "./LinkIcon";

interface SocialLinksProps {
  links: Link[];
  showLabels?: boolean;
}

export const SocialLinks = ({ links, showLabels = false }: SocialLinksProps) => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-4">
      {links.map((link) => (
        <div key={link.id} className="flex flex-col items-center">
          <LinkIcon link={link} />
          {showLabels && link.link_label && (
            <span className="mt-2 text-xs text-brand-secondary">{link.link_label}</span>
          )}
        </div>
      ))}
    </div>
  );
};
